import type { File } from "@tellescope/types-models";

export const formatFileInlineTemplateString = (file: File): string => `{{files.${file.id}.link:${file.name}}}`;
